"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Anchor = _interopRequireDefault(require("../Anchor"));

var _classnames = _interopRequireDefault(require("classnames"));

var _classNames = _interopRequireDefault(require("../../utilities/classNames"));

var _ButtonTypes = require("./ButtonTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Button = /*#__PURE__*/function (_React$Component) {
  _inherits(Button, _React$Component);

  var _super = _createSuper(Button);

  function Button() {
    var _this;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getClassName", (0, _classNames["default"])(Button.displayName));

    return _this;
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          block = _this$props.block,
          children = _this$props.children,
          color = _this$props.color,
          contentLocation = _this$props.contentLocation,
          disabled = _this$props.disabled,
          href = _this$props.href,
          icon = _this$props.icon,
          iconOnly = _this$props.iconOnly,
          iconPosition = _this$props.iconPosition,
          kind = _this$props.kind,
          loading = _this$props.loading,
          modalLabel = _this$props.modalLabel,
          newWindow = _this$props.newWindow,
          onClick = _this$props.onClick,
          shape = _this$props.shape,
          size = _this$props.size,
          innerRef = _this$props.innerRef,
          title = _this$props.title,
          id = _this$props.id,
          role = _this$props.role,
          ariaSelected = _this$props.ariaSelected,
          ariaControls = _this$props.ariaControls,
          tabIndex = _this$props.tabIndex,
          onKeyDown = _this$props.onKeyDown,
          rest = _objectWithoutProperties(_this$props, ["active", "block", "children", "color", "contentLocation", "disabled", "href", "icon", "iconOnly", "iconPosition", "kind", "loading", "modalLabel", "newWindow", "onClick", "shape", "size", "innerRef", "title", "id", "role", "ariaSelected", "ariaControls", "tabIndex", "onKeyDown"]);

      var bodyProps = {
        className: this.getClassName({
          descendantName: "body",
          utilities: Boolean(icon) && iconOnly && "hiddenVisually"
        })
      };
      var iconPositionModifier = iconPosition && iconPosition === _ButtonTypes.IconPosition.LEFT ? "left" : "right";
      var iconProps = {
        className: this.getClassName({
          descendantName: "icon",
          modifiers: iconPositionModifier
        })
      };
      return /*#__PURE__*/_react["default"].createElement(_Anchor["default"], _extends({
        href: href,
        id: id,
        role: role,
        "aria-selected": ariaSelected,
        "aria-controls": ariaControls,
        tabIndex: tabIndex,
        className: this.getClassName({
          modifiers: (0, _classnames["default"])(color, block ? "block" : null, icon && iconOnly ? "iconOnly" : null, size, shape),
          states: (0, _classnames["default"])({
            active: active,
            disabled: disabled,
            loading: loading
          })
        }),
        contentLocation: contentLocation,
        disabled: disabled,
        modalLabel: modalLabel,
        newWindow: newWindow,
        onClick: onClick,
        onKeyDown: onKeyDown,
        kind: kind,
        innerRef: innerRef,
        title: title
      }, rest), icon && iconPositionModifier === _ButtonTypes.IconPosition.LEFT && /*#__PURE__*/_react["default"].createElement("span", iconProps, icon), /*#__PURE__*/_react["default"].createElement("span", bodyProps, children), icon && iconPositionModifier === _ButtonTypes.IconPosition.RIGHT && /*#__PURE__*/_react["default"].createElement("span", iconProps, icon));
    }
  }]);

  return Button;
}(_react["default"].Component);

_defineProperty(Button, "displayName", "Button");

var _default = Button;
exports["default"] = _default;